import { useRouteParams as useRouteParamsBase } from '../../_hooks/useRouteParams';

interface RouteParams {
  clientId: string;
  page?: 'MySettings' | 'FirmSettings';
  controller: 'AdviserSettings' | 'ClientSettings';
}

export const useRouteParams = (): RouteParams => {
  return useRouteParamsBase<RouteParams>();
};
